import Calendar from './icons/calendar.svg';
import Chevron_left from './icons/chevron_left.svg';
import Chevron_right from './icons/chevron_right.svg';
import Area_chart from './icons/area_chart.svg';
import Arrow_downward from './icons/arrow_downward.svg';
import Arrow_upward from './icons/arrow_upward.svg';
import Bookmark_add from './icons/bookmark_add.svg';
import Bookmark from './icons/bookmark.svg';
import Edit from './icons/edit.svg';
import Check_box_outline_blank from './icons/check_box_outline_blank.svg';
import Check_box from './icons/check_box.svg';
import Content_copy from './icons/content_copy.svg';
import Close from './icons/close.svg';
import Dark_mode from './icons/dark_mode.svg';
import Diamond from './icons/diamond.svg';
import Expand_less from './icons/expand_less.svg';
import Expand_more from './icons/expand_more.svg';
import Indeterminate_check_box from './icons/indeterminate_check_box.svg';
import Info from './icons/info.svg';
import Insert_chart_outlined from './icons/insert_chart_outlined.svg';
import Lock from './icons/lock.svg';
import Lock_open from './icons/lock_open.svg';
import Mdi_home_outline from './icons/mdi_home_outline.svg';
import More_horiz from './icons/more_horiz.svg';
import More_vert from './icons/more_vert.svg';
import Open_in_new from './icons/open_in_new.svg';
import Pie_chart_outline from './icons/pie_chart_outline.svg';
import Radio_button_unchecked from './icons/radio_button_unchecked.svg';
import Rocket_launch from './icons/rocket_launch.svg';
import Swap_horiz from './icons/swap_horiz.svg';
import Table_rows from './icons/table_rows.svg';
import Text_snippet from './icons/text_snippet.svg';
import Workspace_premium from './icons/workspace_premium.svg';
import DynSING from './icons/dynSING.svg';
import Add from './icons/add.svg';
import DynasetIcon from './icons/dynasetIcon.svg';
import Facebook from './icons/facebook.svg';
import Notifications from './icons/notifications.svg';
import Radio_button_checked from './icons/radio_button_checked.svg';
import Sync_alt from './icons/sync_alt.svg';
import Vaults from './icons/vaults.svg';
import Dynasets from './icons/dynasets.svg';
import Dao from './icons/dao.svg';
import Privacy from './icons/privacy.svg';
import Topic from './icons/topic.svg';
import People from './icons/people.svg';
import Account_balance_wallet from './icons/account_balance_wallet.svg';
import Attach_money from './icons/attach_money.svg';
import Currency_exchange from './icons/currency_exchange.svg';
import Local_fire_department from './icons/local_fire_department.svg';
import Work_outline from './icons/work_outline.svg';
import Forum from './icons/forum.svg';
import Help_outline from './icons/help_outline.svg';
import Github from './icons/github.svg';
import Metamask from './icons/metamask.svg';
import More_horizontal from './icons/more_horizontal.svg';
import Dashboard from './icons/dashboard.svg';
import Dashboard_light from './icons/dashboard_light.svg';
import Dashboard_dark from './icons/dashboard_dark.svg';
import Downlaod from './icons/downlaod.svg';
import Piechart from './icons/piechart.svg';
import Peopleuser from './icons/peopleuser.svg';
import Gas from './icons/gas.svg';
import Language from './icons/language.svg';
import Fire from './icons/fire.svg';
import Pdf from './icons/pdf.svg';
import Filter_icon from './icons/filter_icon.svg';
import Link from './icons/link.svg';
import Check from './icons/check.svg';
import Arrow_left from './icons/arrow_left.svg';
import Refund from './icons/refund.svg';
import Lock_locked from './icons/lock_locked.svg';
import Lock_unlocked from './icons/lock_unlocked.svg';
import Triangle_down from './icons/triangle_down.svg';
import Triangle_up from './icons/triangle_up.svg';
import Arrow_right_long from './icons/arrow_right_long.svg';
import Eye_open from './icons/eye_open.svg';
import Arrow_curve from './icons/arrow_curve.svg';
import Tune from './icons/tune.svg';
import Arrow_left_outline from './icons/arrow_left_outline.svg';
import List_outline from './icons/list_outline.svg';
import Apps from './icons/apps.svg';
import Arrow_top_right from './icons/arrow_top_right.svg';
import Arrow_top_right_outline from './icons/arrow_top_right_outline.svg';
import Arrow_drop_up from './icons/arrow_drop_up.svg';
import Add_business from './icons/add_business.svg';
import Vault from './icons/vault.svg';
import Vault_dark from './icons/vault_dark.svg';
import Account_circle from './icons/account_circle.svg';
import Liquidity from './icons/liquidity.svg';
import Voting from './icons/voting.svg';
import SdaoStaking from './icons/sdao_staking.svg';
import MigrateAsi from './icons/migrate_asi.svg';
import Migrate from './icons/migrate.svg';
import Migrate_dark from './icons/migrate_dark.svg';
import Exchange from './icons/exchange.svg';
import Document from './icons/document.svg';
import Document_dark from './icons/document_dark.svg';
import Claim from './icons/claim.svg';
import Bridge from './icons/bridge.svg';
import Bridge_dark from './icons/bridge_dark.svg';
import BuySdao from './icons/buy_sdao.svg';
import Menu from './icons/menu.svg';
import Ellipse from './icons/ellipse.svg';
import Coins from './icons/coins.svg';
import Coins_dark from './icons/coins_dark.svg';
import X from './icons/x.svg';
import Discord from './icons/discord.svg';
import Telegram from './icons/telegram.svg';
import Instagram from './icons/instagram.svg';
import Medium from './icons/medium.svg';
import ChainCircleFilled from './icons/chain_circle_filled.svg';
import SignYield from './icons/sign_yield.svg';
import TextGrammar from './icons/text_grammar.svg';
import Warning from './icons/warning.svg';
import Plus from './icons/plus.svg';
import Minus from './icons/minus.svg';
import GeneratingTokens from './icons/generating_tokens.svg';
import Safe from './icons/safe.svg';
import Settings from './icons/settings.svg';
import ArrowDown from './icons/arrow_down.svg';
import School from './icons/school.svg';
import Send from './icons/send.svg';
import Person from './icons/person.svg';
import SmartToy from './icons/smart_toy.svg';
import SmartToyDark from './icons/smart_toy_dark.svg';
import Percent from './icons/percent.svg';
import Delete_forever from './icons/delete_forever.svg';
import ArrowRightAlt from './icons/arrow_right_alt.svg';
import Description from './icons/description.svg';

export const iconsMap = {
  calendar: Calendar,
  chevron_left: Chevron_left,
  chevron_right: Chevron_right,
  area_chart: Area_chart,
  arrow_downward: Arrow_downward,
  arrow_upward: Arrow_upward,
  bookmark_add: Bookmark_add,
  bookmark: Bookmark,
  check_box_outline_blank: Check_box_outline_blank,
  check_box: Check_box,
  content_copy: Content_copy,
  close: Close,
  dark_mode: Dark_mode,
  diamond: Diamond,
  expand_less: Expand_less,
  expand_more: Expand_more,
  edit: Edit,
  indeterminate_check_box: Indeterminate_check_box,
  info: Info,
  insert_chart_outlined: Insert_chart_outlined,
  lock: Lock,
  lock_open: Lock_open,
  mdi_home_outline: Mdi_home_outline,
  more_horiz: More_horiz,
  more_vert: More_vert,
  open_in_new: Open_in_new,
  pie_chart_outline: Pie_chart_outline,
  radio_button_unchecked: Radio_button_unchecked,
  rocket_launch: Rocket_launch,
  swap_horiz: Swap_horiz,
  table_rows: Table_rows,
  text_snippet: Text_snippet,
  workspace_premium: Workspace_premium,
  dynSING: DynSING,
  add: Add,
  dynasetIcon: DynasetIcon,
  facebook: Facebook,
  notifications: Notifications,
  radio_button_checked: Radio_button_checked,
  sync_alt: Sync_alt,
  vaults: Vaults,
  dynasets: Dynasets,
  dao: Dao,
  privacy: Privacy,
  topic: Topic,
  people: People,
  account_balance_wallet: Account_balance_wallet,
  attach_money: Attach_money,
  currency_exchange: Currency_exchange,
  local_fire_department: Local_fire_department,
  work_outline: Work_outline,
  forum: Forum,
  help_outline: Help_outline,
  github: Github,
  metamask: Metamask,
  more_horizontal: More_horizontal,
  dashboard: Dashboard,
  dashboard_light: Dashboard_light,
  dashboards: Dashboard_light,
  dashboards_dark: Dashboard_dark,
  downlaod: Downlaod,
  piechart: Piechart,
  peopleuser: Peopleuser,
  gas: Gas,
  language: Language,
  fire: Fire,
  pdf: Pdf,
  filter_icon: Filter_icon,
  link: Link,
  check: Check,
  arrow_left: Arrow_left,
  arrow_drop_up: Arrow_drop_up,
  refund: Refund,
  lock_locked: Lock_locked,
  lock_unlocked: Lock_unlocked,
  triangle_down: Triangle_down,
  triangle_up: Triangle_up,
  arrow_right_long: Arrow_right_long,
  eye_open: Eye_open,
  arrow_curve: Arrow_curve,
  tune: Tune,
  arrow_left_outline: Arrow_left_outline,
  list_outline: List_outline,
  apps: Apps,
  arrow_top_right: Arrow_top_right,
  arrow_top_right_outline: Arrow_top_right_outline,
  add_business: Add_business,
  vault: Vault,
  vault_dark: Vault_dark,
  account_circle: Account_circle,
  liquidity: Liquidity,
  voting: Voting,
  sdao_staking: SdaoStaking,
  migrate_asi: MigrateAsi,
  migrate: Migrate,
  migrate_dark: Migrate_dark,
  exchange: Exchange,
  document: Document,
  document_dark: Document_dark,
  claim: Claim,
  bridge: Bridge,
  bridge_dark: Bridge_dark,
  buy_sdao: BuySdao,
  menu: Menu,
  ellipse: Ellipse,
  coins: Coins,
  coins_dark: Coins_dark,
  x: X,
  discord: Discord,
  telegram: Telegram,
  instagram: Instagram,
  medium: Medium,
  chain_circle_filled: ChainCircleFilled,
  sign_yield: SignYield,
  text_grammar: TextGrammar,
  warning: Warning,
  plus: Plus,
  minus: Minus,
  generating_tokens: GeneratingTokens,
  safe: Safe,
  settings: Settings,
  arrow_down: ArrowDown,
  school: School,
  send: Send,
  person: Person,
  smart_toy: SmartToy,
  smart_toy_dark: SmartToyDark,
  percent: Percent,
  delete_forever: Delete_forever,
  arrow_right_alt: ArrowRightAlt,
  description: Description,
} as const;

export type IconName = keyof typeof iconsMap;
